import { Component, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd';
import { BsModalRef } from 'ngx-bootstrap';
import { ChangeModeApp, OfflineOperationsActionsService } from './offline-operations-actions.service';
@Component({
  selector: 'app-offline-operations-actions',
  templateUrl: './offline-operations-actions.component.html',
  styleUrls: ['./offline-operations-actions.component.css']
})
export class OfflineOperationsActionsComponent implements OnInit {
  public areYouSure: string = '¿Estás seguro que quieres activar ';
  showConfirm: boolean = false;
  textButton: string = 'Activar a en línea';
  intervalValidateApp: any;
  contValidateApp: number = 0;
  showSpinner: boolean = true;
  showError: boolean = false;
  infoUserLogged: any;
  statusAppMode: boolean = true
  textTitle: string = "";
  textSpinner: string = "Cargando...";
  messageResponse = "No se pudo obtener la modalidad, inténtelo más tarde.";

  constructor(
    public bsModalRef: BsModalRef,
    private offlineOperationsActionsService: OfflineOperationsActionsService,
    private notification: NzNotificationService,
  ) { }

  ngOnInit() {
    this.validate();
    this.intervalValidateApp = setInterval(() => {
      if (this.contValidateApp < 3) {
        this.validate();
      }
    }, 10000);
  }
  validate() {
    this.textSpinner = "Cargando...";
    this.messageResponse = 'No se pudo obtener la modalidad, inténtelo más tarde.'
    this.showSpinner = true;
    this.showError = false;
    setTimeout(() => {
      this.offlineOperationsActionsService.validateModeApp().subscribe((response: any) => {
        debugger
        this.statusAppMode = response.estado_apk;
        if (response.estado_apk) {
          this.contValidateApp = 4;
          clearInterval(this.intervalValidateApp);
          this.areYouSure = this.areYouSure + 'en línea?';
          this.textButton = 'Activar en línea';
          this.showSpinner = false;
          this.textTitle = 'Fuera de línea';
        }
        else {
          this.contValidateApp = 4;
          clearInterval(this.intervalValidateApp);
          this.textButton = 'Activar fuera de línea';
          this.areYouSure = this.areYouSure + 'fuera de línea?';
          this.showSpinner = false;
          this.textTitle = 'En línea';
        }
      }, () => {
        this.contValidateApp++;
        if (this.contValidateApp == 3) {
          this.showError = true;
          clearInterval(this.intervalValidateApp);
          this.showSpinner = false;
          this.createNotification('warning', 'No fue posible obtener la modalidad', 'Consulte con el administrador de la aplicación');
        }
      });
    }, 2000);
  }
  changeModeApp() {
    this.textSpinner = "Actualizando...";
    this.showSpinner = true;
    let changeModeApp = new ChangeModeApp();
    this.infoUserLogged = JSON.parse(localStorage.getItem('info_user_logged'));
    this.statusAppMode ? changeModeApp.estado_apk = false : changeModeApp.estado_apk = true;
    changeModeApp.idUsuario = (this.infoUserLogged.userAppView.idUserApp).toString();
    this.offlineOperationsActionsService.changeModeApp(changeModeApp).subscribe((response: any) => {
      if (response == "INSERTADO CORRECTAMENTE") {
        this.showSpinner = false;
        this.createNotification('success', 'Se actualizó la modalidad', 'Todos los usuarios se actualizarán a la nueva modalidad');
        setTimeout(() => {
          this.cerrarModal();
        }, 10000);
        this.showError = true;
        this.messageResponse = 'Actualización de la modalidad con éxito.';
      }
      else {
        this.showSpinner = false;
        this.createNotification('error', 'No fue posible actualizar la modalidad', 'Por favor inténtelo nuevamente.');
        setTimeout(() => {
          this.cerrarModal();
        }, 10000); this.showError = true;
        this.messageResponse = 'No fue posible actualizar la modalidad, por favor inténtelo nuevamente.';
      }
    }, (error) => {
      this.showSpinner = false;
      this.createNotification('error', 'No fue posible actualizar la modalidad', 'Por favor inténtelo nuevamente.');
      setTimeout(() => {
        this.cerrarModal();
      }, 10000);
      this.showError = true;
      this.messageResponse = 'No fue posible actualizar la modalidad, por favor inténtelo nuevamente.';
    });
  }
  cerrarModal() {
    this.bsModalRef.hide();
  }
  confirm(): void {
    this.showConfirm = true;
  }
  createNotification(type: string, title?: string, content?: string): void {
    this.notification.config({
      nzPlacement: 'bottomRight'
    });
    this.notification.create(
      type,
      title,
      content,
      {
        nzAnimate: true,
      }
    );
  }
}
